import * as Scrivito from "scrivito"

import { BuildingReferencesOverviewPage } from "pages/building-references-overview-page/BuildingReferencesOverviewPage"

import { BuildingReferencesOverviewPageObjClass } from "./BuildingReferencesOverviewPageObjClass"

Scrivito.provideComponent(
  BuildingReferencesOverviewPageObjClass,
  BuildingReferencesOverviewPage
)
